import { connectFela } from '../../dependencies';
import ExportForm from './ExportForm';
import * as styles from './ExportForm.styles';

export default connectFela(styles)(ExportForm);
